module.exports = __webpack_public_path__ + "images/jobs/dollarBag.94199580.svg";